import React, { Fragment, useState, useEffect } from 'react'
import { withStyles } from '@material-ui/styles'

import CampaignEmptyStateD2D from '../CampaignEmptyStateD2D'
import CampaignEmptyStateH2H from '../CampaignEmptyStateH2H'
import CampaignEmptyStateEDDM from '../CampaignEmptyStateEDDM'
import CampaignEmptyStateADM from '../CampaignEmptyStateADM'
import CampaignEmptyState from '../CampaignEmptyState'

import styles from './styles'
import CampaignEmptyStateAIM from '../CampaignEmptyStateAIM'

const EmptyStateRouteManager = ({
  classes,
  route,
  subRoute,
  handleCreateCampaign,
  client,
  isSelfServeEnabled,
  enabledChannels = [],
  isLoading,
}) => {
  const channelRoutes = ['d2d', 'dm', 'h2h', 'inserts']

  const channels = {}

  for (let i = 0; i < enabledChannels.length; i++) {
    const key = enabledChannels[i].subtype || enabledChannels[i].type
    channels[key] = key
  }

  const [currentSubRoute, setCurrentSubRoute] = useState(subRoute)

  useEffect(() => {
    // avoids flashing the empty state when the route is loading
    if (!isLoading) {
      setCurrentSubRoute(subRoute)
    }
  }, [subRoute, isLoading])

  const EmptyRoute = route => {
    switch (route) {
      case 'd2d': {
        return (
          <CampaignEmptyStateD2D
            isSelfServeEnabled={isSelfServeEnabled}
            enabledChannel={channels.LETTERBOX}
            handleCreateCampaign={handleCreateCampaign}
            validRoute={channelRoutes.includes(route)}
            route={route}
            classes={classes}
          />
        )
      }
      case 'h2h': {
        return (
          <CampaignEmptyStateH2H
            isSelfServeEnabled={isSelfServeEnabled}
            enabledChannel={channels.HANDTOHAND}
            handleCreateCampaign={handleCreateCampaign}
            validRoute={channelRoutes.includes(route)}
            route={route}
            classes={classes}
          />
        )
      }
      case 'dm': {
        return currentSubRoute === 'eddm' ? (
          <CampaignEmptyStateEDDM
            isSelfServeEnabled={isSelfServeEnabled}
            enabledChannel={channels.EDDM}
            handleCreateCampaign={handleCreateCampaign}
            validRoute={channelRoutes.includes(route)}
            route={route}
            subRoute={currentSubRoute}
            classes={classes}
          />
        ) : (
          <CampaignEmptyStateADM
            isSelfServeEnabled={isSelfServeEnabled}
            enabledChannel={channels.ADM}
            handleCreateCampaign={handleCreateCampaign}
            validRoute={channelRoutes.includes(route)}
            route={route}
            subRoute={currentSubRoute}
            classes={classes}
          />
        )
      }
      case 'inserts': {
        return (
          <CampaignEmptyStateAIM
            isSelfServeEnabled={isSelfServeEnabled}
            enabledChannel={channels.AIM}
            handleCreateCampaign={handleCreateCampaign}
            validRoute={channelRoutes.includes(route)}
            route={route}
            classes={classes}
          />
        )
      }
      default: {
        return (
          <CampaignEmptyState
            client={client}
            handleCreateCampaign={handleCreateCampaign}
            isSelfServeEnabled={isSelfServeEnabled}
            enabledChannels={enabledChannels}
            route={route}
            classes={classes}
          />
        )
      }
    }
  }

  return <Fragment>{EmptyRoute(route)}</Fragment>
}
export default withStyles(styles)(EmptyStateRouteManager)
